import router from '@approuter' // Vue router instance

/**
 * Import Dependency
 */
import * as types from '@appstore/mutations_types'

/**
 * Import API
 */
import usersAPI from '@appservices/api/app/users'


let SESSION_KEY = 'USERS_FILTERS';
/**
 * Declare Variable
 */
const state = {
	filters: sessionStorage.getItem(SESSION_KEY) ? JSON.parse(sessionStorage.getItem(SESSION_KEY)) : null
}

const getters = {
	filters : state => {
		return state.filters
	},
}

const actions = {

	setFilters({ commit, dispatch }, context) {
		commit('setFilters', context);
	},

	async get({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.get(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data && response.data.status ? response.data.status.message : 'An unexpected error occurred.',
					addclass: 'bg-danger border-danger'
				}, {root:true});
				return Promise.reject(response.data)
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async misc({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.misc(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true})
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async status({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.status(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true})
				return Promise.reject(e)
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async admin({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.admin(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true})
				return Promise.reject(e)
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async download({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.download(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true});
				return Promise.reject(response.data)
			}

		} catch (e) {
			return Promise.reject(e)
		}
	},

	async getById({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.getById(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true});
				return Promise.reject(response.data)
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async delete({ commit, dispatch }, context) {
		try {
			const response = await usersAPI.delete(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
					text: response.data.status.message,
					addclass: 'bg-danger border-danger'
				}, {root:true});
				return Promise.reject(response.data)
			}
		} catch (e) {
			return Promise.reject(e)
		}
	},

}
const mutations = {
	setFilters(state, value) {
		state.filters = { ...value };
		sessionStorage.setItem(SESSION_KEY, JSON.stringify(state.filters));
	}
}

/**
 * Export
 */
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}